/* cl-rapi.js — replica do widget Rapi Bundles do concorrente (rapi.py), vanilla.
   - barra: clique seleciona (radio nativo + o estilo inline que o app dele aplica, capturado ao vivo) e abre os
     seletores por unidade (#1..#N: dropdown de cor com foto + select de taglia);
   - timer "L'offerta scade tra" 10:00 -> 00:00 (reinicia), por sessao;
   - cross-sell (checkbox): a escova entra no mesmo POST;
   - form.__clItems(): o cl-ui.js pergunta no submit -> [{id, quantity}] das unidades escolhidas (+ escova).
   Sem barra escolhida, o ATC usa a 1a (como o app dele). Variantes = as da NOSSA loja ([data-cl-variants]). */
(function () {
  'use strict';
  var SEL = { shadow: 'rgb(187, 85, 137) 0px 0px 0px 2px inset', bg: 'rgba(111, 66, 193, 0.06)', border: '#bb5589ff' };
  var OFF = { shadow: 'rgba(187, 85, 137, 0.48) 0px 0px 0px 2px inset', bg: 'rgb(255, 255, 255)', border: '#bb55897a' };

  function variantsOf(host) {
    var d = host.querySelector('[data-cl-variants]');
    try { return JSON.parse(d.textContent); } catch (e) { return []; }
  }
  function find(vs, opts) {
    for (var i = 0; i < vs.length; i++) {
      var ok = true;
      for (var k = 0; k < opts.length; k++) if (opts[k] != null && vs[i].options[k] !== opts[k]) { ok = false; break; }
      if (ok) return vs[i];
    }
    return null;
  }

  function init(root) {
    if (root.__clRapi) return; root.__clRapi = true;
    var host = root.closest('[data-cl-pdp]') || document;
    /* na k o widget fica FORA do form (o app dele liga por form=): o form do buybox e o do mesmo host */
    var form = root.closest('form') || host.querySelector('form[id^="product-form-"]') || host.querySelector('form[action*="/cart/add"]');
    var vs = variantsOf(host);
    var bars = Array.prototype.slice.call(root.querySelectorAll('[data-cl-rapi-bar]'));

    function paint() {
      bars.forEach(function (b) {
        var r = b.querySelector('input[type="radio"]'), lab = b.querySelector('label.rapi-bundles__bar-container');
        var on = !!(r && r.checked), st = on ? SEL : OFF;
        if (lab) { lab.style.boxShadow = st.shadow; lab.style.backgroundColor = st.bg; lab.style.setProperty('--bar-border-color', st.border); }
        var v = b.querySelector('.rapi-bundles__bar-variants'); if (v) v.style.display = on ? 'block' : 'none';
      });
    }
    bars.forEach(function (b) {
      var r = b.querySelector('input[type="radio"]');
      if (r) { r.removeAttribute('readonly'); r.addEventListener('change', paint); }
    });
    root.addEventListener('click', function (e) {
      /* dropdown de cor (div do app): abre/fecha; opcao escolhida vira o valor da unidade */
      var btn = e.target.closest('.rapi-dropdown-button');
      if (btn) {
        e.preventDefault(); e.stopPropagation();
        var c = btn.parentNode.querySelector('.rapi-dropdown-content'), open = c && c.classList.contains('rapi-d-none');
        root.querySelectorAll('.rapi-dropdown-content').forEach(function (x) { x.classList.add('rapi-d-none'); });
        if (c && open) c.classList.remove('rapi-d-none');
        return;
      }
      var opt = e.target.closest('.rapi-dropdown-content-single-option');
      if (opt) {
        e.preventDefault(); e.stopPropagation();
        var dd = opt.closest('.rapi-dropdown'), val = opt.textContent.trim();
        var inp = dd.querySelector('input.rapi-select-value'); if (inp) inp.value = val;
        var t = dd.querySelector('.rapi-dropdown-text'); if (t) t.textContent = val;
        var sw = opt.querySelector('.rapi-dropdown-content-swatch'), img = dd.querySelector('.rapi-dropdown-img');
        if (sw && img) img.style.setProperty('--swatch-image-url', sw.style.getPropertyValue('--swatch-image-url'));
        opt.parentNode.classList.add('rapi-d-none');
        return;
      }
      /* clicar nos seletores nao pode trocar de barra (o label envolve tudo) */
      if (e.target.closest('.rapi-bundles__bar-variants')) { if (e.target.tagName !== 'SELECT') e.preventDefault(); }
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) root.querySelectorAll('.rapi-dropdown-content').forEach(function (x) { x.classList.add('rapi-d-none'); });
    });
    paint();

    function unitsOf(bar) {
      var out = [];
      bar.querySelectorAll('.rapi-bundles__bar-variant').forEach(function (row) {
        var opts = [];
        row.querySelectorAll('input.rapi-select-value, select.rapi-bundles__bar-variant-select').forEach(function (el) {
          var m = (el.className.match(/rapi_option_\d+_\d+_(\d+)/) || [])[1];
          opts[m != null ? +m : opts.length] = el.value;
        });
        out.push(opts);
      });
      return out;
    }
    if (form) {
      form.__clItems = function () {
        var bar = bars.filter(function (b) { var r = b.querySelector('input[type="radio"]'); return r && r.checked; })[0] || bars[0];
        if (!bar) return null;
        var n = parseInt(bar.getAttribute('data-cl-units'), 10) || 1, rows = unitsOf(bar), qty = {};
        var fallback = (form.querySelector('input[name="id"]') || {}).value;
        for (var i = 0; i < n; i++) {
          var v = rows[i] ? find(vs, rows[i]) : null;
          var id = v ? v.id : parseInt(fallback, 10);
          if (!id) continue;
          qty[id] = (qty[id] || 0) + 1;
        }
        var items = Object.keys(qty).map(function (k) { return { id: parseInt(k, 10), quantity: qty[k] }; });
        var xs = host.querySelector('[data-cl-xs]');
        if (xs && xs.checked) items.push({ id: parseInt(xs.getAttribute('data-cl-xs'), 10), quantity: 1 });
        return items;
      };
    }
  }

  /* timer flip: MM:SS em contagem regressiva de 10 min, por sessao */
  function timers() {
    var boxes = document.querySelectorAll('[data-cl-tflip]'); if (!boxes.length) return;
    var t0 = 0;
    try { t0 = parseInt(sessionStorage.getItem('cl-rapi-t0'), 10) || 0; } catch (e) {}
    if (!t0) { t0 = Date.now(); try { sessionStorage.setItem('cl-rapi-t0', String(t0)); } catch (e) {} }
    function tick() {
      var left = 600 - Math.floor((Date.now() - t0) / 1000) % 600;
      if (left === 600) left = 0;
      var mm = ('0' + Math.floor(left / 60)).slice(-2), ss = ('0' + (left % 60)).slice(-2);
      boxes.forEach(function (b) {
        var d = b.querySelectorAll('.timer-flip-digit');
        [mm, ss].forEach(function (v, i) { if (d[i]) d[i].querySelectorAll('.timer-flip-digit__number').forEach(function (n) { n.textContent = v; }); });
      });
    }
    tick(); setInterval(tick, 1000);
  }

  function boot() { document.querySelectorAll('[data-cl-rapi]').forEach(init); timers(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
